import { render } from "./Avatar.vue?vue&type=template&id=751fd7ea&scoped=true"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"

import "./Avatar.vue?vue&type=style&index=0&id=751fd7ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751fd7ea"]])

export default __exports__